(() => {
  class ElvaCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.viewport = this.querySelector('[data-elva-viewport]');
      if (!this.viewport) return;

      this.querySelector('[data-elva-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-elva-next]')?.addEventListener('click', () => this.move(1));

      this.querySelectorAll('[data-elva-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-elva-filter]').forEach((item) => {
            item.setAttribute('aria-selected', String(item === button));
          });
          const category = button.dataset.elvaFilter;
          this.querySelectorAll('[data-elva-category]').forEach((item) => {
            item.hidden = category !== 'all' && item.dataset.elvaCategory !== category;
          });
          this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
        });
      });
    }

    move(direction) {
      const visibleItem = [...this.querySelectorAll('[data-elva-category], .elva-carousel__item')]
        .find((item) => !item.hidden);
      const distance = visibleItem ? visibleItem.getBoundingClientRect().width + 18 : this.viewport.clientWidth * .8;
      this.viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }
  }

  if (!customElements.get('elva-carousel')) {
    customElements.define('elva-carousel', ElvaCarousel);
  }
})();
